export enum TiposDeCoberturaDeEnvio {
    SEM_PRECO = 'SEM_PRECO',
    PRECO_FIXO = 'PRECO_FIXO',
    DISTANCIA_RAIO_METROS = 'DISTANCIA_RAIO_METROS',
    DISTANCIA_POR_KM = 'DISTANCIA_POR_KM'
}
